import List from './List';
import reducer from './reducer';

const WarehouseBalances = {
  List,
  reducer
};

export default WarehouseBalances;
